import { SentimentPrediction } from '@modules/feedback/store/types';

export const toSentimentManipulations = (
  sentimentPrediction?: SentimentPrediction,
) => {
  if (!sentimentPrediction) {
    return [];
  }

  return [
    {
      manipulationType: sentimentPrediction.manipulationType,
      recordSentiment: {
        sentiment: sentimentPrediction.prediction,
      },
    },
  ];
};
